type Vec3 = { x: number; y: number; z: number };

export function computeKnockbackDirection(mobPos: Vec3, playerPos: Vec3): { x: number; z: number } {
  const dx = playerPos.x - mobPos.x;
  const dz = playerPos.z - mobPos.z;
  const len = Math.sqrt(dx * dx + dz * dz);
  if (len < 0.001) return { x: 0, z: 1 };
  return { x: dx / len, z: dz / len };
}
